export default class FinesseHeader extends HTMLElement {
  header: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.header = this.querySelector('header')

    window.addEventListener('announcement:toggle', this.handleAnnouncement.bind(this) as EventListener)
  }

  handleAnnouncement(event: CustomEvent): void {
    const announcementActive = event.detail.active
    const announcementHeight = event.detail.height - 2

    if (this.header) {
      this.header.style.top = announcementActive ? `${announcementHeight}px` : ''
    }
  }
}

customElements.define('finesse-header', FinesseHeader)
